import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "image-preview"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["src", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, null, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Report Issue")
              ])),
              _: 1,
              __: [7]
            }),
            _createVNode(_component_ion_buttons, { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { class: "ion-padding" }, {
      default: _withCtx(() => [
        (_ctx.viewMode === 'form')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_ion_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("Program")
                        ])),
                        _: 1,
                        __: [8]
                      }),
                      _createVNode(_component_ion_input, {
                        readonly: "",
                        value: _ctx.programName
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("Issue Type")
                        ])),
                        _: 1,
                        __: [9]
                      }),
                      _createVNode(_component_ion_select, {
                        interface: "popover",
                        modelValue: _ctx.issueType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.issueType) = $event)),
                        placeholder: "Select issue type"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select_option, { value: "inaccurate_info" }, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createTextVNode("Inaccurate Information")
                            ])),
                            _: 1,
                            __: [10]
                          }),
                          _createVNode(_component_ion_select_option, { value: "calculation_error" }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode("Calculation Error")
                            ])),
                            _: 1,
                            __: [11]
                          }),
                          _createVNode(_component_ion_select_option, { value: "missing_data" }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode("Missing Data")
                            ])),
                            _: 1,
                            __: [12]
                          }),
                          _createVNode(_component_ion_select_option, { value: "other" }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode("Other")
                            ])),
                            _: 1,
                            __: [13]
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode("Description")
                        ])),
                        _: 1,
                        __: [14]
                      }),
                      _createVNode(_component_ion_textarea, {
                        modelValue: _ctx.description,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
                        placeholder: "Please describe the issue in detail",
                        rows: 5
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "stacked" }, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode("Screenshot (optional)")
                        ])),
                        _: 1,
                        __: [15]
                      }),
                      _createVNode(_component_ion_input, {
                        type: "file",
                        accept: "image/*",
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onImageFileChange($event)))
                      }),
                      (_ctx.photo)
                        ? (_openBlock(), _createBlock(_component_ion_buttons, {
                            key: 0,
                            slot: "end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearUploadedImage()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_ctx.photo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("img", { src: _ctx.photo }, null, 8, _hoisted_3)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                expand: "block",
                onClick: _ctx.submitReport,
                disabled: !_ctx.isFormValid
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode(" Submit Report ")
                ])),
                _: 1,
                __: [16]
              }, 8, ["onClick", "disabled"]),
              (_ctx.hasSubmittedReports)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 0,
                    expand: "block",
                    fill: "clear",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.viewMode = 'history'))
                  }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createTextVNode(" View Previous Reports ")
                    ])),
                    _: 1,
                    __: [17]
                  }))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.viewMode === 'history')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_ion_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_list_header, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createTextVNode("Previous Reports")
                          ])),
                          _: 1,
                          __: [18]
                        })
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previousReports, (report, index) => {
                      return (_openBlock(), _createBlock(_component_ion_item, { key: index }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.getIssueTypeLabel(report.issueType)), 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(report.createdAt)), 1),
                              _createElementVNode("p", null, _toDisplayString(report.message), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (report.photo)
                            ? (_openBlock(), _createBlock(_component_ion_thumbnail, {
                                key: 0,
                                slot: "end"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    src: report.photo,
                                    onClick: ($event: any) => (_ctx.openImageModal(report.photo))
                                  }, null, 8, _hoisted_5)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    (_ctx.previousReports.length === 0)
                      ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-center" }, {
                              default: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createTextVNode(" No previous reports found ")
                              ])),
                              _: 1,
                              __: [19]
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  expand: "block",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.viewMode = 'form'))
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode(" Back to Report Form ")
                  ])),
                  _: 1,
                  __: [20]
                })
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}